import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';
import NoteListItem from 'app/main/submodules/notes/NotesListItem';
import { showAddNotesDialog } from './NotesAddDialog';

export default function DetailsSectionNotes({ module, uid }: { module: string; uid: string }) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	function addNote() {
		dispatch(
			showAddNotesDialog({
				model: {
					note_table: module,
					note_table_uid: uid
				},
				updateRefresh
			})
		);
	}

	return (
		<DetailsSectionWrapper
			avatar={<Icon icon="comment-text-multiple-outline" />}
			title={t('NOTES_SECTION')}
			subheader={t('NOTES_SUBHEADER')}
			headerAction={
				<IconButton onClick={addNote}>
					<Icon icon="comment-plus-outline" />
				</IconButton>
			}
			disablePadding
		>
			<ViewList
				module="notes"
				itemLayout={NoteListItem}
				defaultFilters={[
					{
						filt_field: 'note_table',
						filt_clause: 'equals',
						filt_value: module
					},
					{
						filt_field: 'note_table_uid',
						filt_clause: 'equals',
						filt_value: uid
					}
				]}
				refresh={refresh}
				updateRefresh={updateRefresh}
				showExportButton={false}
			/>
		</DetailsSectionWrapper>
	);
}
